module.exports = __webpack_public_path__ + "img/mazer-scene-1.e6fd95ad.jpg";